import React, { useEffect, useRef } from 'react';
import Button from 'components/Buttons/Button/Button';
import translate from '../../utils/fnTranslate';
import { ConfigErrorWrapper, ConfigErrorTitle, ConfigErrorBody } from './ConfigErrorScreen.css';

interface ConfigErrorScreenProps {
    onRetry: () => void;
    isRetrying?: boolean;
}

// this screen renders before ApplicationConfig is populated, where translate() returns the key itself
const TRANSLATION_FALLBACK = {
    ERR_NO_INTERNET_TITLE: 'Internet puudub',
    ERR_NO_INTERNET_BODY: 'Kontrolli internetiühendust ja proovi uuesti',
    TRY_AGAIN_BUTTON: 'Proovi uuesti',
    LOADING: 'Laadin...',
};

const label = (key: keyof typeof TRANSLATION_FALLBACK): string => {
    const translation = translate(key);

    return translation === key ? TRANSLATION_FALLBACK[key] : translation;
};

export const ConfigErrorScreen: React.FC<ConfigErrorScreenProps> = ({ onRetry, isRetrying = false }) => {
    const titleRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        const focusTimeout = window.setTimeout(() => titleRef.current?.focus(), 0);

        return () => window.clearTimeout(focusTimeout);
    }, []);

    return (
        <ConfigErrorWrapper>
            <ConfigErrorTitle ref={titleRef} tabIndex={-1}>
                {label('ERR_NO_INTERNET_TITLE')}
            </ConfigErrorTitle>
            <ConfigErrorBody>{label('ERR_NO_INTERNET_BODY')}</ConfigErrorBody>
            <Button
                isPrimary={true}
                label={isRetrying ? label('LOADING') : label('TRY_AGAIN_BUTTON')}
                isDisabled={isRetrying}
                onClick={onRetry}
            />
        </ConfigErrorWrapper>
    );
};

export default ConfigErrorScreen;
